
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 0L9.106 9.08 0 9.169l7.32 5.698L4.583 24 12 18.44 19.417 24l-2.737-9.134L24 9.168l-9.106-.087z","opacity":".999","paint-order":"stroke markers fill"}})])
          )
        }
      }
    